import { LockOutlined, MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../../../components/layout/AuthLayout';
import { registerUser } from '../../../redux/actions/auth';
import { getRoutes } from '../../../routes/Routes';
import { moduleName } from '../../../constants';

const Register = () => {
  const navigate = useNavigate();
  const { loading, module } = useSelector((state) => state.loadingSlice);


  const onFinish = async (values) => {
    const res = await registerUser(values);
    if (res?.ack) {
      navigate(getRoutes().login.route());
    }
  };

  return (
    <AuthLayout
      title="Create an Account"
      subtitle="Sign up to get started"
      actionText="Already have an account?"
      actionLabel="Log In"
      actionLink={getRoutes().login.route()}
      maxWidth={800}
    >
      <Form layout="vertical" size="large" onFinish={onFinish} className="tight-form">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="first_name"
              label="First Name"
              rules={[{ required: true, message: 'Please enter your first name' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="John" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="last_name"
              label="Last Name"
              rules={[{ required: true, message: 'Please enter your last name' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="Doe" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please enter your email' },
            { type: 'email', message: 'Please enter a valid email address' },
          ]}
        >
          <Input prefix={<MailOutlined />} placeholder="john.doe@example.com" />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Phone Number"
        >
          <Input prefix={<PhoneOutlined />} placeholder="+44 7123 456 789" />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="password"
              label="Password"
              rules={[
                { required: true, message: 'Please enter your password' },
                { min: 6, message: 'Password must be at least 6 characters long' },
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Enter your password" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="confirmPassword"
              label="Confirm Password"
              dependencies={['password']}
              rules={[
                { required: true, message: 'Please confirm your password' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Passwords do not match'));
                  },
                }),
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Confirm your password" />
            </Form.Item>
          </Col>
        </Row>

        <Button
          type="primary"
          htmlType="submit"
          block
          loading={loading && module === moduleName.REGISTER}
          size="large"
          className="mt-2"
        >
          Register
        </Button>
      </Form>
    </AuthLayout>
  );
};

export default Register;
